import type { PlpFilterDTO, PlpFiltersResponseDTO } from '../dto/filters.dto';
import type { ListingFilter, ListingFilterItem, PlpFiltersResult } from '../../domain/models/Filter';

export function mapFilterDtosToListingFilters(data: PlpFilterDTO[]): ListingFilter[] {
  return (data ?? []).map((f) => ({
    category: f.category,
    items: (f.filterItemList ?? []).map(
      (item): ListingFilterItem => ({
        name: item.name,
        displayName: item.displayName,
        count: item.count,
        url: item.url,
        selected: item.selected,
      })
    ),
  }));
}

export function adaptFiltersResponseDto(input: PlpFiltersResponseDTO | Record<string, unknown>): PlpFiltersResult {
  const record = input as Record<string, unknown>;
  const filtersRaw = record.filters;
  const filters = Array.isArray(filtersRaw)
    ? mapFilterDtosToListingFilters(filtersRaw as PlpFilterDTO[])
    : [];
  const filtersResetUrl = typeof record.filtersResetUrl === 'string' ? record.filtersResetUrl : undefined;
  const categoryTagForFiltersReset =
    typeof record.categoryTagForFiltersReset === 'string' ? record.categoryTagForFiltersReset : undefined;
  const selectedTags = record.selectedTags != null ? String(record.selectedTags) : record.selectedTags as null | undefined;
  const floatingFilters = record.floatingFilters;
  return {
    filters,
    ...(filtersResetUrl && { filtersResetUrl }),
    ...(categoryTagForFiltersReset && { categoryTagForFiltersReset }),
    ...(selectedTags !== undefined ? { selectedTags } : {}),
    ...(floatingFilters != null ? { floatingFilters } : {}),
  };
}
